module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1280.534f054a.png";